import { render } from "./SideModal.vue?vue&type=template&id=8244dc58"
import script from "./SideModal.vue?vue&type=script&lang=js"
export * from "./SideModal.vue?vue&type=script&lang=js"

import "./SideModal.vue?vue&type=style&index=0&id=8244dc58&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__